'use strict'
import $ from 'jquery'

const defaultShowLength = 6
const Num = 6
const moreListButton = document.querySelector('.js-moreList')
const workList = document.querySelector('._WorksIndex__itemContainer')
const workListItem = '._WorksIndexItem'
const workListItemHide = $('._WorksIndexItem:gt('+(defaultShowLength-1)+')')
const WorksIndexMore = document.querySelector('._WorksIndex__more')
const selected = document.getElementById("select-link")

window.addEventListener('DOMContentLoaded', () => {
  $(workListItem + ':nth-child(n + ' + (defaultShowLength + 1) + ')').addClass('is-hidden')
  if($(workListItem).length > defaultShowLength) {
    workListItemHide.hide()
  } else {
    WorksIndexMore.style.display = 'none'
  }
})

moreListButton.addEventListener('click', () => {
  // $(workListItem).fadeIn()
  // WorksIndexMore.style.display = 'none'
  $(workListItem + '.is-hidden').slice(0, Num).removeClass('is-hidden').fadeIn()
  if ($(workListItem + '.is-hidden').length == 0) {
    WorksIndexMore.style.display = 'none'
  }
})

selected.onchange = function() {
    window.location.href = selected.value;
};